import { OrganizationBusinessRepository } from '@/businessRepository/organizationBusinessRepository';
import { IArrival } from '@/coreDomainsModule/entities/arrival';
import { IBusiness } from '@/coreDomainsModule/entities/businessBase';
import { IAnnounce } from '@/coreDomainsModule/entities/forecast';
import { INetworkResult } from '@/coreDomainsModule/networkResult';

/**
 * 取引情報をシステムに保存する
 */
export class BulkRegisterBusinessUseCase {
  /**
   * businessに、recommendとsupplierAnnounceを結合したentryを合成し、保存する
   * @param repository - 取引情報の永続化の責務を負うクラス
   * @param businesses - 取引情報
   * @returns 失敗した時はエラーを返す
   */
  async Execute(repository: OrganizationBusinessRepository, businesses: IBusiness[]): Promise<INetworkResult<void, Error>> {
    try {
      return await repository.balkSave(businesses);
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: Error('保存に失敗しました'),
        },
      };
    }
  }
}
